// extracted by mini-css-extract-plugin
module.exports = {"inventoryTag":"InventoryTag_inventoryTag__2LCtJ","isDesktop":"InventoryTag_isDesktop__faqPz"};